export default __webpack_public_path__ + "static/media/season-change.20914da7.png";